export default "/images/cc50ea05446a2bddc525ded2cd36ecbd.png";